"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SonarGlobalTimeout = void 0;
class SonarGlobalTimeout {
    constructor(delay, context) {
        this.clearTimeout = () => {
            if (typeof this.timeout === 'number') {
                clearTimeout(this.timeout);
            }
        };
        this.setTimeout = () => {
            this.timeout = setTimeout(() => {
                this.context();
            }, this.delay);
        };
        this.delay = delay;
        this.context = context;
    }
}
exports.SonarGlobalTimeout = SonarGlobalTimeout;
//# sourceMappingURL=lib.js.map